<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.PURCHASE'"> </span>s</h3>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <!-- Section Wrap Start -->
                <section class="inner-section-wrap">
                    <!-- Site Content Block Start -->
                    <div class="table-wrap px-3 py-2 dark-bg border-radius20">
                        <!-- Table Start -->
                        <div class="table-responsive table-block table-border-dark">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>. </th>
                                        <th scope="col"><span [translate]="'GREATER.DATE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.AMOUNT'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span> </th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span> </th>  
                                        <th scope="col"><span [translate]="'GREATER.TRANSACTION_ID'"> </span> </th>

                                        <!-- <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span> </th>   -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of PurchaseList | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <th scope="row">
                                            {{i+1}}
                                        </th>
                                        <td>{{service.convertDate(item.createdAt)}}</td>
                                        <td>{{loginDetail.userCurrencySymbol }} {{item.txnAmout}}</td>
                                        <td *ngIf="item.txnFor!='Subscribe'">{{item.txnFor}}</td>
                                        <td *ngIf="item.txnFor=='Subscribe'">Subscription</td>
                                        <td *ngIf="item.txnFor!='Subscribe'">{{item.title}} </td>
                                        <td *ngIf="item.txnFor=='Subscribe'">1 Month </td>
                                        <td>{{item.txnUniqueId}}</td>
                                        <!-- <td class="action-btn-box">
                                            <a href="javascript:void(0);" class="btn action-btn ic-fill-btn" (click)="getPurchaseDetail(item._id)"> <i class="gricon gr_ic_eye font-24"></i> </a>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-4">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="p=$event" class="text-center" *ngIf="PurchaseList.length > 0"></pagination-controls>
                            </div>

                        </div>
                        <!-- Table End -->
                    </div>
                </section>
                <!-- Section Wrap End -->


            </div>
        </div>

    </div>
    <app-footer></app-footer>
</main>